import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { UkToAuComponent } from 'src/app/components/shop-from-pages/uk-to-au-component/uk-to-au-component';
import { UsToIlComponent } from 'src/app/components/shop-from-pages/us-to-il-component/us-to-il.component';
import { UsToSgComponent } from 'src/app/components/shop-from-pages/us-to-sg-component/us-to-sg.component';
import { UsToDeComponent } from 'src/app/components/shop-from-pages/us-to-de-component/us-to-de.component';
import { UsToAuComponent } from 'src/app/components/shop-from-pages/us-to-au-component/us-to-au.component';
const routes: Routes = [
  {
    path: 'shop-from-uk-to-au', component: UkToAuComponent
  },
  {
    path: "shop-from-us-to-il", component: UsToIlComponent
  },
  {
    path: "shop-from-us-to-sg", component: UsToSgComponent
  },
  {
    path: "shop-from-us-to-de", component: UsToDeComponent
  },
  {
    path: "shop-from-us-to-au", component: UsToAuComponent
  },
]

@NgModule({
  declarations: [
    UkToAuComponent,
    UsToIlComponent,
    UsToSgComponent,
    UsToDeComponent,
    UsToAuComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    
  ]
})
export class MarketingModuleModule { }